import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/admin/AuthContext";
import { ProtectedRoute } from "@/admin/ProtectedRoute";
import { Landing } from "@/Landing";
import { Login } from "@/admin/Login";
import { ForgotPassword } from "@/admin/ForgotPassword";
import { ResetPassword } from "@/admin/ResetPassword";
import { AdminLayout } from "@/admin/AdminLayout";
import { Dashboard } from "@/admin/pages/Dashboard";
import { RoomsAdmin } from "@/admin/pages/RoomsAdmin";
import { LeadsAdmin } from "@/admin/pages/LeadsAdmin";
import { UsersAdmin } from "@/admin/pages/UsersAdmin";
import { SettingsAdmin } from "@/admin/pages/SettingsAdmin";
import { GalleryAdmin } from "@/admin/pages/GalleryAdmin";

function App() {
  return (
    <div className="App font-poppins">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin/forgot-password" element={<ForgotPassword />} />
            <Route path="/admin/reset-password" element={<ResetPassword />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="habitaciones" element={<RoomsAdmin />} />
              <Route path="prospectos" element={<LeadsAdmin />} />
              <Route
                path="usuarios"
                element={
                  <ProtectedRoute role="super_admin">
                    <UsersAdmin />
                  </ProtectedRoute>
                }
              />
              <Route
                path="configuracion"
                element={
                  <ProtectedRoute role="super_admin">
                    <SettingsAdmin />
                  </ProtectedRoute>
                }
              />
              <Route
                path="galeria"
                element={
                  <ProtectedRoute role="super_admin">
                    <GalleryAdmin />
                  </ProtectedRoute>
                }
              />
            </Route>
          </Routes>
          <Toaster position="top-center" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
